import { render, staticRenderFns } from "./PartnerProfitOrderPackageList.vue?vue&type=template&id=a400a0b4&scoped=true&"
import script from "./PartnerProfitOrderPackageList.vue?vue&type=script&lang=js&"
export * from "./PartnerProfitOrderPackageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a400a0b4",
  null
  
)

export default component.exports